import {
  AdditiveBlending,
  BufferAttribute,
  BufferGeometry,
  Mesh,
  Object3D,
  Points,
  Vector3,
} from 'three';
import { appMixin } from '../../utils/appMixin';
import { ParticlesMaterial } from '../Materials/Particles/material';

export class Particles extends appMixin(Object3D) {
  constructor(app) {
    super(app);

    const center = new Vector3();
    const count = 200;
    const positions = new Float32Array(count * 3 * 3);
    const uvs = new Float32Array(count * 3 * 2);
    for (let i = 0; i < count; i++) {
      center.set(Math.random(), Math.abs(Math.sin(i)) * Math.PI * 2, i);

      positions[i * 9 + 0] = center.x;
      positions[i * 9 + 1] = center.y;
      positions[i * 9 + 2] = center.z;

      positions[i * 9 + 3] = center.x;
      positions[i * 9 + 4] = center.y;
      positions[i * 9 + 5] = center.z;

      positions[i * 9 + 6] = center.x;
      positions[i * 9 + 7] = center.y;
      positions[i * 9 + 8] = center.z;

      uvs[i * 6 + 0] = 0;
      uvs[i * 6 + 1] = 0;

      uvs[i * 6 + 2] = 1;
      uvs[i * 6 + 3] = 0;

      uvs[i * 6 + 4] = 1;
      uvs[i * 6 + 5] = 1;
    }
    const geometry = new BufferGeometry();

    geometry.setAttribute('position', new BufferAttribute(positions, 3));
    geometry.setAttribute('uv', new BufferAttribute(uvs, 2));

    this.points = new Mesh(
      geometry,
      new ParticlesMaterial({
        uniforms: {
          ...this.app.uniforms,
          cameraPos: { value: new Vector3() },
          uParticlesEffectIntensity: this.app.particlesEffectIntensity,
          uCoolEffectIntensity: this.app.coolEffectIntensity,
        },
        blending: AdditiveBlending,
        depthWrite: false,
        depthTest: false,
      })
    );

    this.add(this.points);
  }
}
